/* Preview-only bootstrap: no network or AI request before customer interaction. */
(() => {
  if (customElements.get('blb-advisor')) return;
  customElements.define('blb-advisor', class extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.blb-advisor-trigger');
      if (!this.trigger) return;
      this.abort = new AbortController();
      this.trigger.hidden = false;
      this.openPanel = async (opener) => {
        if (this.loading) return;
        this.loading = true;
        try {
          if (!this.controller) this.controller = (await import(this.dataset.panelUrl)).mount(this);
          await this.controller.open(opener);
        } catch { this.trigger.textContent = this.dataset.error; }
        finally { this.loading = false; }
      };
      this.trigger.addEventListener('click', () => this.openPanel(this.trigger), { signal: this.abort.signal });
      this.contextButtons = [...document.querySelectorAll('[data-blb-advisor-context]')]
        .filter((button) => button.dataset.productHandle === this.dataset.handle);
      this.contextButtons.forEach((button) => {
        button.hidden = false;
        button.addEventListener('click', () => this.openPanel(button), { signal: this.abort.signal });
      });
      this.observer = new IntersectionObserver(() => this.avoidObstructions());
      document.querySelectorAll('footer, sticky-add-to-cart, mobile-purchase-bar, .mobile-purchase, .shopify-pc__banner, #shopify-pc__banner, [data-sticky-add]').forEach((node) => this.observer.observe(node));
      this.contextButtons.forEach((node) => this.observer.observe(node));
      // Obstacles can appear after load (cart drawer, consent banner, sticky bar).
      // Watch the DOM so a late arrival is noticed, and coalesce the reaction into
      // one frame so a burst of mutations costs a single measurement.
      this.mutations = new MutationObserver((records) => {
        if (records.every((record) => this.contains(record.target))) return;
        if (this.obstructionFrame) return;
        this.obstructionFrame = requestAnimationFrame(() => {
          this.obstructionFrame = null;
          this.avoidObstructions();
        });
      });
      this.mutations.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['hidden','style','class']});
      this.onScroll = () => this.avoidObstructions();
      window.addEventListener('scroll', this.onScroll, {passive:true, signal:this.abort.signal});
      window.addEventListener('resize', this.onScroll, {passive:true, signal:this.abort.signal});
      this.avoidObstructions();
    }
    avoidObstructions() {
      const visible = (node) => {
        const box = node.getBoundingClientRect();
        return box.width > 0 && box.height > 0 && box.top < innerHeight && box.bottom > 0
          && getComputedStyle(node).visibility !== 'hidden';
      };
      // Lift the launcher above the footer while it is on screen, rather than
      // hiding it: the advisor stays reachable at every scroll position.
      const footer = [...document.querySelectorAll('footer')].find(visible);
      const top = footer?.getBoundingClientRect().top;
      const offset = footer ? Math.max(24, innerHeight - top + 16) : (innerWidth < 750 ? 16 : 24);
      if (this.style.getPropertyValue('--blb-advisor-bottom') !== offset + 'px') this.style.setProperty('--blb-advisor-bottom', offset + 'px');
      const blocked = [...document.querySelectorAll('.shopify-pc__banner,#shopify-pc__banner,[data-sticky-add],mobile-purchase-bar,.mobile-purchase')].some(visible);
      const contextVisible = this.contextButtons?.some(visible);
      this.trigger.hidden = Boolean(blocked || contextVisible);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.mutations?.disconnect();
      if (this.obstructionFrame) cancelAnimationFrame(this.obstructionFrame);
      this.controller?.destroy();
    }
  });
})();
